import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import { ReactNode, useEffect, useState } from 'react';
import './core.css';
export default function PWASplash({ children }: { children: ReactNode }) {
    const [loding, setLoding] = useState(true);
    const [isFirstVisit, setIsFirstVisit] = useState(true);
    const isPWA = window.matchMedia('(display-mode: standalone)').matches;
    useEffect(() => {
        const hasVisited = sessionStorage.getItem("hasVisited");
        if (hasVisited) {
            setIsFirstVisit(false);
        } else {
            sessionStorage.setItem("hasVisited", "true");
        }
        setTimeout(() => {
            setLoding(false);
        }, 500);
        const metaThemeColor = document.querySelector('meta[name="theme-color"]');
        metaThemeColor!.setAttribute('content', `var(--bg-color)`);
    }, []);
    return (
        <>
            {loding ? (

                <div
                    style={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                        height: '100%',
                        background: `var(--bg-color)`,
                        textAlign: 'center',
                        color: 'var(--primary-text-color)',
                        zIndex: "999"
                    }}
                >
                    <PwaLoading />
                    {/* {isPWA ? <PwaLoading /> : <CircularProgress />} */}

                </div>

            ) : (
                children
            )}
        </>
    );
}

const PwaLoading = () => {
    return (
        <>
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: 10 }}>
                <span className="dot-anim"><FiberManualRecordIcon sx={{ fontSize: '1rem', color: "var(--primary-text-color)" }} /></span>
                <span className="dot-anim" style={{ animationDelay: '0.2s' }}><FiberManualRecordIcon sx={{ fontSize: '1rem', color: "var(--primary-text-color)" }} /></span>
                <span className="dot-anim" style={{ animationDelay: '0.4s' }}><FiberManualRecordIcon sx={{ fontSize: '1rem', color: "var(--primary-text-color)" }} /></span>
                <span className="dot-anim" style={{ animationDelay: '0.6s' }}><FiberManualRecordIcon sx={{ fontSize: '1rem', color: "var(--primary-text-color)" }} /></span>
                <style>
                    {`
                .dot-anim {
                    font-size: 2rem;
                    opacity: 0.3;
                    animation: dotBlink 1s infinite;
                    margin: 0 2px;
                }
                @keyframes dotBlink {
                    0%, 100% { opacity: 0.3; }
                    50% { opacity: 1; }
                }
                `}
                </style>
            </div>
            <div className='pt-5 text-[var(--primary-text-color)]'>
                لطفا منتظر باشید
            </div>
        </>)
}